<script>
import { blockBatchesList, getBatchesList } from "@/api/batches";
import { changeBatchesList } from "@/api/batches";

export default {
  name: "FileBatchesSettings",
  data() {
    return {
      isVisible: true,
      batches: [],
      loading: false,
      hasMounted: false,
    };
  },
  created() {
    this.getBatches();
  },
  methods: {
    async getBatches() {
      this.loading = true;
      try {
        const { data } = await getBatchesList();
        this.batches = data || [];
        await this.$nextTick(() => {
          this.hasMounted = true; // Enable change detection after render
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async changeBatch(batch_id, is_active) {
      try {
        const { data } = await changeBatchesList(batch_id, is_active);
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    },
    async handleBatchBlockChange(row, val) {
      const newValue = row.batch_block === undefined ? true : val;

      try {
        await blockBatchesList(row._id, newValue, true);
      } catch (error) {
        console.error(error);
      }
    },
    close() {
      this.$router.push({ name: "settings" });
    },
  },
};
</script>

<template>
  <el-drawer
    size="600"
    title="Партия файлов"
    v-model="isVisible"
    @close="close"
  >
    <div class="h-full overflow-y-auto" v-loading="loading">
      <el-table :data="batches" border style="width: 100%" size="small">
        <el-table-column
          prop="batch_name"
          label="Название партии"
          min-width="200"
        >
          <template #default="{ row }">
            <span>{{ row.batch_name || "-" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Видимость батча" align="center" width="150">
          <template #default="{ row }">
            <el-switch
              v-model="row.is_active"
              @change="
                (newValue) => hasMounted && changeBatch(row._id, newValue)
              "
              :active-value="true"
              :inactive-value="false"
              inline-prompt
              style="
                --el-switch-on-color: #13ce66;
                --el-switch-off-color: #a1a1a1;
              "
            />
          </template>
        </el-table-column>

        <el-table-column label="Блокировка батча" align="center" width="150">
          <template #default="{ row }">
            <el-switch
              v-model="row.batch_block"
              @change="
                (newValue) =>
                  hasMounted && handleBatchBlockChange(row, newValue)
              "
              :active-value="true"
              :inactive-value="false"
              inline-prompt
              style="
                --el-switch-on-color: #ff5040;
                --el-switch-off-color: #a1a1a1;
              "
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-drawer>
</template>

<style scoped lang="scss"></style>
